import * as React from "react";

import { Sticky } from "../../../Sticky/Sticky";
import { emptyRef } from "../../../../TypingUtils";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { PagerContainer as Pager } from "../../../../FormParts/Pager/PagerContainer";
import { PagerContainer } from "../Footer/Footer.styles";

export interface ExpectProps {
    bindingPath: AbsoluteModelPath;
    filteredUniqKey: string;
}

export class MultilinePager extends React.Component<ExpectProps> {
    public stop: HTMLElement | null = emptyRef;
    public sticky: null | Sticky = emptyRef;

    public componentDidMount(): void {
        this.sticky?.setStop(this.stop ?? undefined);
    }

    public render(): JSX.Element {
        return (
            <div data-type="multiline-row">
                <PagerContainer style={{ marginLeft: 40 }}>
                    <Pager bindingPath={this.props.bindingPath} filteredUniqKey={this.props.filteredUniqKey} />
                </PagerContainer>
            </div>
        );
    }
}
